module.exports = __webpack_public_path__ + "img/759e0cddc06934eaa6fb5fe79c3e25eb.png";